
import React from 'react';
import { Box, Container, CssBaseline } from '@mui/material';
import Header from './Header';
import Footer from './Footer';
import PendingRewardBanner from '../../features/redeem/components/PendingRewardBanner';

interface MainLayoutProps {
  children: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children, maxWidth = 'lg' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: 'transparent',
      }}
    >
      <CssBaseline />
      <Header />
      {/* Convention coupon pending-reward reminder. The banner
          self-gates on `isAuthenticated` + the presence of live
          pending rewards from /coupons/my, so it's safe to mount on
          every page (public OR authed) — it renders null otherwise. */}
      <PendingRewardBanner />
      <Container
        component="main"
        maxWidth={maxWidth}
        sx={{
          flexGrow: 1,
          py: 4,
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: 'transparent',
        }}
      >
        {children}
      </Container>
      <Footer />
    </Box>
  );
};

export default MainLayout;
